import React from 'react';
import classNames from 'classnames';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import { Picture } from 'components/Picture';
import fallbackAuthorImg from 'assets/images/fallback-author.svg';
import { LinkIfHref } from '../Link';
import styles from './styles.module.scss';

/**
 * AuthorCard component renders an author card with an image, name, and job title.
 * @param {object} props - The component props.
 * @param {string} props.name - The name of the author. If not provided, a brand fallback will be shown.
 * @param {string} props.imageURL - The URL of the author's image.
 * @param {string} props.jobTitle - The job title of the author.
 * @param {string} props.linkURL - The URL to link to when the card is clicked.
 */
export function AuthorCard({
  imageURL, jobTitle, linkURL, name,
}) {
  return (
    <LinkIfHref href={linkURL}>
      <div className={classNames(styles.container, { [styles.hover]: linkURL })} data-testid="author-card">
        {imageURL ? (
          <Picture
            url={imageURL}
            responsiveFlavors={{
              s: AIMS_FLAVORS.FOCAL_100x100,
              m: AIMS_FLAVORS.FOCAL_100x100,
              l: AIMS_FLAVORS.FOCAL_100x100,
            }}
            className={styles.image}
          />
        ) : (
          <img src={fallbackAuthorImg} alt={name} className={styles.image} />
        )}
        <div className={styles.nameContainer}>
          <p className={styles.name}>{name}</p>
          {jobTitle && (
            <p className={styles.jobTitle}>{jobTitle}</p>
          )}
        </div>
      </div>
    </LinkIfHref>
  );
}
